import { TextHighlighter } from "../utils/textHighlighter"

export const JobUpdateDesc = ({job_update, searchTerm, ...props}) => {
    const renderHighlight = (customClass, content) => {
        return (
            <TextHighlighter typography={{className: customClass}} contentString={content} toMatch={searchTerm} highlightStyle={{background: "var(--color-action-primary-disabled)", textTransform: "capitalize"}}/>
        )
    }

    return (
        <div className="body-s flex items-center flex-wrap newsfeed__job-update-desc">
            {renderHighlight('body-s preWrap', `${job_update.name} has started a new position as `)}
            {renderHighlight('body-s-semibold', job_update.designation)}
            {renderHighlight('body-s preWrap', `${job_update.company_name ? " at " : " "}`)}
            {renderHighlight('body-s-semibold', job_update.company_name)}
            {renderHighlight('body-s preWrap', `${job_update.location ? ", " : " "}`)}
            {renderHighlight('body-s-semibold', job_update.location)}
        </div>
    )

}
